import { safeParseApiError } from '../utils/parseApiError';

export function useApiFormErrorHandler() {
  return (
    error: unknown,
    setErrors: (errors: Record<string, string>) => void,
    setApiError: (error: string) => void
  ) => {
    const { fieldErrors, generalMessage } = safeParseApiError(error);

    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
    } else {
      setApiError(generalMessage);
    }
  };
}
